<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import EditModal from "./EditModal.vue";
    import DarkDropdown from "./DarkDropdown.vue";
    import ProgressInput from "./ProgressInput.vue";
    @Component({
        components: {
            EditModal,
            DarkDropdown,
            ProgressInput,
        },
    })
    export default class ChartLabelModal extends Vue {
        modalName = "label";
        defaultPosition = {
            left: 280,
            top: 340,
        };
        @Prop()
        label;
        tempLabel = {
            show: true,
            distance: 5,
            rotate: 0,
            position: "top",
        };
        get positionList() {
            return [
                {
                    label: this.$t("hidden"),
                    value: "hidden",
                },
                {
                    label: this.$t("top"),
                    value: "top",
                },
                {
                    label: this.$t("inside"),
                    value: "inside",
                },
            ];
        }
        selectPosition(index: number) {
            let data = this.positionList[index];
            this.tempLabel.position = data.value;
            this.$emit("changeLabel", this.tempLabel);
        }
        changeAngle(data: number) {
            this.tempLabel.rotate = data;
            this.$emit("changeLabel", this.tempLabel);
        }
        changeGap(data: number) {
            this.tempLabel.distance = data;
            this.$emit("changeLabel", this.tempLabel);
        }
        handleClose() {
            this.$emit("closeEvent");
        }
        mounted() {
            this.tempLabel = Object.assign(this.tempLabel, JSON.parse(JSON.stringify(this.label)));
            for (let i = 0; i < this.positionList.length; i++) {
                if (this.tempLabel.position == this.positionList[i].value) {
                    (this.$refs.dropdownEl as any).setActiveIndex(i);
                    break;
                }
            }
        }
    }
</script>

<template>
    <EditModal :name="modalName" :title="$t('title')" :width="208" :position="defaultPosition" @closeEvent="handleClose">
        <div class="dropdown-item">
            <p class="dropdown-title textoverflow" :title="$t('angle')">{{ $t("angle") }}</p>
            <ProgressInput class="dropdown-box" :max="90" :min="-90" :data="tempLabel.rotate" @changeInput="changeAngle" :key="tempLabel.rotate" />
        </div>
        <div class="dropdown-item">
            <p class="dropdown-title textoverflow" :title="$t('position')">{{ $t("position") }}</p>
            <DarkDropdown ref="dropdownEl" class="dropdown-box" :data="positionList" :defaultIndex="0" @selectData="selectPosition" />
        </div>
        <div class="dropdown-item">
            <p class="dropdown-title textoverflow" :title="$t('gap')">{{ $t("gap") }}</p>
            <ProgressInput class="dropdown-box" :max="20" :min="0" :data="tempLabel.distance" @changeInput="changeGap" :key="tempLabel.distance" />
        </div>
    </EditModal>
</template>

<style lang="stylus" scoped>
    .dropdown-item
        position relative
        display flex
        justify-content space-between
        align-items center
        padding 0 4px
        &:not(.last-child)
            margin-bottom 8px
        .dropdown-box
            width 128px
        .dropdown-title
            margin-right 12px
            font-size 12px
            color #fff
            max-width 48px
        .dropdown-color
            position absolute
            right 20px
            top 4px
            width 24px
            height 12px
            border-radius 4px
            z-index 1
</style>
<i18n>
{
    "zh" : {
        "title": "标签设置",
        "angle": "标签角度",
        "position": "标签位置",
        "gap": "标签间距",
        "hidden": "隐藏",
        "top": "顶部",
        "inside": "内部",
        "bottom": "底部"
    },
    "en": {
        "title": "Label Settings",
        "angle": "Label Angle",
        "position": "Label Position",
        "gap": "label Spacing",
        "hidden": "Hide",
        "top": "Top",
        "inside": "Internal",
        "bottom": "Bottom"
    },
    "de" : {
        "title": "Beschriftungs-Einstellungen",
        "angle": "Beschriftungswinkel",
        "position": "Beschriftungsposition",
        "gap": "Beschriftungsabstand",
        "hidden": "Ausblenden",
        "top": "Oben",
        "inside": "Intern",
        "bottom": "Unten"
    },
    "es" : {
        "title": "Configuración de etiquetas",
        "angle": "Ángulo de etiqueta",
        "position": "Posición de etiqueta",
        "gap": "Espaciado de etiqueta",
        "hidden": "Ocultar",
        "top": "Superior",
        "inside": "Interno",
        "bottom": "Inferior"
    },
    "fr" : {
        "title": "Paramètres d'étiquette",
        "angle": "Angle d'étiquette",
        "position": "Position de l'étiquette",
        "gap": "Espacement des étiquettes",
        "hidden": "Masquer",
        "top": "Haut",
        "inside": "Interne",
        "bottom": "Bas"
    },
    "id" : {
        "title": "Pengaturan Label",
        "angle": "Sudut Label",
        "position": "Posisi Label",
        "gap": "Jarak Label",
        "hidden": "Sembunyikan",
        "top": "Atas",
        "inside": "Internal",
        "bottom": "Bawah"
    },
    "it" : {
        "title": "Impostazioni etichetta",
        "angle": "Angolo etichetta",
        "position": "Posizione etichetta",
        "gap": "Spaziatura etichette",
        "hidden": "Nascondi",
        "top": "Superiore",
        "inside": "Interno",
        "bottom": "Interno"
    },
    "jp" : {
        "title": "ラベルの設定",
        "angle": "ラベルの角度",
        "position": "ラベルの位置",
        "gap": "ラベルの間隔",
        "hidden": "非表示",
        "top": "上",
        "inside": "内部",
        "bottom": "下"
    },
    "kr" : {
        "title": "라벨 설정",
        "angle": "라벨 각도",
        "position": "라벨 위치",
        "gap": "라벨 간격",
        "hidden": "숨기기",
        "top": "위",
        "inside": "내부",
        "bottom": "아래"
    },
    "pt" : {
        "title": "Configurações da etiqueta",
        "angle": "Ângulo da etiqueta",
        "position": "Posição da etiqueta",
        "gap": "Espaçamento da etiqueta",
        "hidden": "Ocultar",
        "top": "Superior",
        "inside": "Interno",
        "bottom": "Inferior"
    },
    "tw" : {
        "title": "標籤設定",
        "angle": "標籤角度",
        "position": "標籤位置",
        "gap": "標籤間距",
        "hidden": "隱藏",
        "top": "頂端",
        "inside": "內部",
        "bottom": "底部"
    }
}
</i18n>
